// extracted by mini-css-extract-plugin
export default {"spaceBottom":"shared-styles_spaceBottom__mv-k7","fullWidth":"shared-styles_fullWidth__hzpSs","modalDescription":"shared-styles_modalDescription__H+RCG"};